import React from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Chip,
    Box,
} from '@mui/material';

interface TagsMultiSelectProps {
    availableTags: string[];
    selectedTags: string[];
    onTagsChange: (tags: string[]) => void;
    disabled?: boolean;
}

export const TagsMultiSelect: React.FC<TagsMultiSelectProps> = ({
    availableTags,
    selectedTags,
    onTagsChange,
    disabled = false,
}) => {
    const handleChange = (event: any) => {
        const value = event.target.value;
        onTagsChange(typeof value === 'string' ? value.split(',') : value);
    };

    const renderValue = (selected: string[]) => {
        if (selected.length === 0) {
            return null;
        }

        const maxVisibleTags = 1;
        const visibleTags = selected.slice(0, maxVisibleTags);
        const remainingCount = selected.length - maxVisibleTags;

        return (
            <Box sx={{ display: 'flex', gap: 0.5, maxWidth: '200px', overflow: 'hidden' }}>
                {visibleTags.map((value) => (
                    <Chip key={value} label={value} size="small" />
                ))}
                {remainingCount > 0 && (
                    <Chip
                        label={`+${remainingCount}`}
                        size="small"
                        sx={{ backgroundColor: 'action.selected', fontWeight: 'bold' }}
                    />
                )}
            </Box>
        );
    };

    return (
        <FormControl sx={{ minWidth: 200, maxWidth: 220 }} disabled={disabled}>
            <InputLabel>Tags</InputLabel>
            <Select
                multiple
                value={selectedTags}
                onChange={handleChange}
                input={<OutlinedInput label="Tags" />}
                renderValue={renderValue}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 224,
                            width: 250,
                        },
                    },
                }}
            >
                {availableTags.map((tag) => (
                    <MenuItem key={tag} value={tag}>
                        <Checkbox checked={selectedTags.indexOf(tag) > -1} />
                        <ListItemText primary={tag} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
